// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__uLexz","header":"MergedInvoice_header__LxECp"};